import {
  LabelInput,
  EntryTypeSelect,
  StandardDesignConfig,
  RequiredToggle,
  ReadOnlyToggle,
  HideOnPdfToggle,
} from 'apps/studio/components/settings/fields/Base/standard'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

import { lib } from '@gocanvas/client'
const {
  getCurrentTime,
  TimeField: { getTimeFormat },
} = lib

const TimeStyleSelect = {
  label: 'Style',
  settingType: 'selectInput',
  size: "large",
  updateType: 'entry',
  property: 'style',
  choices: [
    {
      label: 'AM/PM',
      value: 1,
    },
    {
      label: '24 Hour',
      value: 0,
    },
    {
      label: 'HH:MM:SS',
      value: 2,
    },
    {
      label: 'MM:SS',
      value: 3,
    },
  ],
}

const TimeDefaultSelect = {
  label: 'Default',
  settingType: 'selectInput',
  updateType: 'entry',
  property: 'default',
  size: "large",
  dynamicChoices: ({ default: defaultValue, style }) => {
    return [
      { label: 'Current Time', value: null },
      { label: 'No Default (Blank)', value: 'BLANK' },
      {
        label: 'Custom Time',
        value:
          defaultValue && defaultValue !== 'BLANK'
            ? defaultValue
            : getCurrentTime(getTimeFormat(style)),
      },
    ]
  },
}

const CustomTimePicker = {
  label: 'Custom Time',
  settingType: 'timePicker',
  updateType: 'entry',
  property: 'default',
  showInput: ({ default: defaultValue }) => {
    return defaultValue && defaultValue !== 'BLANK'
  },
}

export const TimeStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  TimeDefaultSelect,
  TimeStyleSelect,
  CustomTimePicker,
  RequiredToggle,
  ReadOnlyToggle,
  ...StandardDesignConfig,
  HideOnPdfToggle,
]
